"use strict";

var _defineProperty = require("/mnt/ephemeral/jenkins/workspace/lucid-co-gatsby/corporate/node_modules/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("../../../theme/styled"));

var emotion_theming_1 = require("emotion-theming");

var NavbarItem = styled_1.default.li(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    label: 'navbarItem',
    flex: '0 1 auto',
    alignSelf: 'flex-start',
    listStyle: 'none',
    margin: "auto ".concat(theme.navbar.itemSpacing)
  }, "@media (max-width: ".concat(theme.navbar.collapseAt, ")"), {
    margin: 0,
    borderTop: "1px solid ".concat(theme.navbar.borderColor),
    padding: '1rem 2rem',
    width: '100%',
    'button, a': {
      padding: theme.navbar.dropdown.mobilePadding
    },
    a: {
      paddingLeft: 0,
      paddingRight: 0
    },
    'a.is-button': {
      padding: theme.navbar.dropdown.mobilePadding
    },
    'button.is-link': {
      paddingLeft: 0,
      paddingRight: 0
    }
  });
});
exports.default = emotion_theming_1.withTheme(NavbarItem);